<!--
 * @Author: 夏元元 xiayuanyuan@itcast.cn
 * @Date: 2024-12-30 17:21:30
 * @LastEditors: 夏元元 xiayuanyuan@itcast.cn
 * @LastEditTime: 2025-01-17 09:51:30
 * @FilePath: \subject-topic-new\components\coursePage\design\Box8.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="box8">
    <pageTitle title="常见问题" titleColor="#313433"  />

    <commomProblem
      class="box box2"
      :problemData="problemData"
      :styleData="styleData"
      
    />
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import commomProblem from "../common/commom-problem.vue";
export default {
  components: {
    pageTitle,
    commomProblem,
  },
  data() {
    return {
      problemData: [
        {
          title: "直接购买项目库里的项目，都享受哪些服务？",
          answer:["交付内容：项目设计文档、项目代码包、开题报告参考，安装教程视频、功能演示视频、项目修改指导视频、论文撰写辅导视频、代码讲解视频，15天答疑服务"]
        },
        {
          title: "成品项目指导和定制项目指导有什么区别？",
          answer:["成品项目是常见的毕设课题，定制指导可以根据你的毕设题目量身定制"]
        },
        {
          title: "定制项目指导需要等待多久交付？",
          answer:["定制需要从0启动，所以一般是7-14个工作日交付"]
        },
        {
          title: "定制项目如何保证交付的时效性？",
          answer:["会签署协议，保证时效性不耽误您的使用"]
        },
      ],
      styleData: {
        iconQuestion: require("../../../assets/coursePage/java/box11/icon.png"),
      },
    };
  },
  methods: {
    zixun(name) {
      this.mai("AI大模型训练营","了解更多",0,null)
      this.clickZiXun()
    },
  },
};
</script>

<style lang="scss" scoped>
.box8 {
  padding: 80px 0px 88px;
  width: 100%;
  background: url("../../../assets/coursePage/design/box8/bg.png")
    no-repeat;
  background-size: cover;

  .box ,.box2{
    margin-top: 48px;
    ::v-deep {
      .item-answer {
        display: inline-block;
      }
    }
  }
 .box2{
  ::v-deep {
      .content-box {
        padding: 16px 32px 16px 24px;
      }
      .icon{
        margin-left: 0 !important;
      }
      .left{
        white-space: nowrap;
      }
    }
 }
}
</style>
